import { render } from "./create_riskframework.html?vue&type=template&id=01ea538f&external"
import script from "./create_riskframework.js?vue&type=script&lang=js&external"
export * from "./create_riskframework.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__